/**
 * The console's sign-in screen — design "Led AI - Console Sign In", 1a
 * ("Split — ink brand panel, paper form").
 *
 * Everything shared with sign-up — the frame, the brand panel, the Clerk
 * theming, the strings — lives in `authFrame.tsx`, which is also where the
 * reasoning for the split between our markup and Clerk's is written down.
 * This file is the sign-in half of that arrangement and nothing else.
 */

import { SignIn } from "@clerk/clerk-react";
import { AuthFrame, AUTH_APPEARANCE } from "./authFrame";
import { consoleUrl } from "../basePath";

/** 1a, assembled: the frame, with Clerk's themed `<SignIn>` in the slot. */
export function SignInScreen() {
  return (
    <AuthFrame
      screen="sign-in"
      form={
        <SignIn
          routing="hash"
          appearance={AUTH_APPEARANCE}
          fallbackRedirectUrl={consoleUrl("/")}
          signUpUrl={consoleUrl("/sign-up")}
        />
      }
    />
  );
}
